import React, { useEffect, useState } from "react";

import {
    Platform,
    View
} from "react-native";
import NavBarButton from "./NavBarButton";
import { IcFilter } from "../../utils/Icons";
import AppTheme from "../../utils/Theme";
import Modal from "../../../specific/components/Modal/Modal";
import UserLevelSelection from "../Filters/UserLevelSelection";
import i18n from "../../utils/Localization/Localization";
import User from "../../data/user/User";
import { EventRegister } from "../../utils/EventListeners";
import { EventFiltersByLevelChanged, EventUserAuthDB } from "../../utils/Constants";
import Text from "../ReactNative/Text";
import { useSpecificSize } from "../../../specific/Theme/SpecificSize";

interface NavBarTitleProps {
    title: string;
    titleColor?: string;
    showLevel?: boolean;
    navBarButtons?: boolean;
}

const NavBarTitle = (props: NavBarTitleProps) => {

    const appTheme: AppTheme = new AppTheme();
    const user: User = User.getInstance();

    const {
        fullScreenWidth,
        fullScreenHeight,
        availableScreenSize,
        contentSize,
        sideMenuSize,
        horizontalSpacing
    } = useSpecificSize();

    const [refresh, setRefresh] = useState<number>(0);

    const { navBarButtons = false, title, showLevel = true, titleColor = appTheme.darkBlue } = props;

    useEffect(() => {
        EventRegister.addEventListener(EventFiltersByLevelChanged, (data) => {
            setRefresh(new Date().getTime());
        });
        return () => {
            EventRegister.removeEventListener(EventFiltersByLevelChanged);
        };
    }, []);

    const renderLevel = () => {
        if (showLevel === false) {
            return <View />
        }
        const levelTitle: string = user.profile === "teacher" ? i18n.t("levels." + user.children_level) : i18n.t("filters." + user.children_level);
        return <Text style={{ color: titleColor, fontFamily: appTheme.primarySemiBoldFont, fontSize: appTheme.pixelPerfectForFont(7), textAlign: "center" }}>{levelTitle.toLocaleLowerCase()}</Text>
    }

    const textPaddingHorizontal: number = navBarButtons === false ? appTheme.pixelPerfect(20) : appTheme.pixelPerfect(40);

    return <View style={{ width: availableScreenSize, alignItems: "center", minHeight: appTheme.pixelPerfect(50), justifyContent: "flex-start" }}>
        <Text type="super_hero_title" style={{ paddingTop: Platform.OS === "web" ? appTheme.pixelPerfect(10) : appTheme.pixelPerfect(5), paddingBottom: appTheme.pixelPerfect(5), paddingHorizontal: textPaddingHorizontal, color: titleColor, fontSize: appTheme.pixelPerfectForFont(10), textAlign: "center" }}>{title.toLocaleUpperCase()}</Text>
        {renderLevel()}
    </View>
}

export default NavBarTitle;